import { formatDate } from '../CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_ISO_FNS, DATE_FORMAT_LONG_FNS } from '../CorePackage/MainModule/constants/dateFormats';

export const renderDateForDisplayedSignatureInfo = (date: string | undefined) => {
  if (!date) {
    return '';
  }

  return formatDate({
    date,
    dateFormat: DATE_FORMAT_LONG_FNS,
    parseFormat: DATE_FORMAT_ISO_FNS,
  });
};
